import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import BarChartCommonComponent from '../../../library/SimpleControls/BarChartCommonComponent';
import useDashboard from './useDashboard';

const ApplicationsOverTime = () => {
    const { state } = useContext(SmartContext);
    const { getApplicationsOverTime } = useDashboard();

    useEffect(() => {
        getApplicationsOverTime();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.applicationsOverTime))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state?.data?.dashboardData?.applicationsOverTime} />
        </>
    );
};

export default ApplicationsOverTime;
